<div class="blade-wrapper">
  <div class="blade-header">
    <div *ngIf="!$hasMissingRequiredInParams" class="blade-tools">
        <app-toolbar [toolbar]="toolbar">
            <ng-template 
              toolbarToolDef="confirm" let-tool>
              <ng-container  *ngIf="tool.hasButtonsToShow">
              <button mat-button
                      data-cy="button"
                      class="datex-button"
                      [disabled]="tool.control.readOnly || tool.control.disabled"
                      [ngStyle]="tool.control.styles.style"
                      [ngClass]="tool.control.styles.classes"
                      [matTooltip]="tool.control.tooltip"
                      matTooltipClass="datex-control-tooltip"
                      (click)="on_confirm_clicked($event)"
                      >
                <div class="button-label">
                  <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                    <div class="button-icon">
                      <i data-cy="button-icon" class="datex-default-spinner"></i>
                    </div>
                  </ng-container>
                  <ng-template #showIcon>
                    <div class="button-icon">
                      <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                    </div>
                  </ng-template>
                  <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
                </div>
              
              </button>
              </ng-container>
            </ng-template>
            <ng-template 
              toolbarToolDef="cancel" let-tool>
              <ng-container  *ngIf="tool.hasButtonsToShow">
              <button mat-button
                      data-cy="button"
                      class="datex-button"
                      [disabled]="tool.control.readOnly || tool.control.disabled"
                      [ngStyle]="tool.control.styles.style"
                      [ngClass]="tool.control.styles.classes"
                      [matTooltip]="tool.control.tooltip"
                      matTooltipClass="datex-control-tooltip"
                      (click)="on_cancel_clicked($event)"
                      >
                <div class="button-label">
                  <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                    <div class="button-icon">
                      <i data-cy="button-icon" class="datex-default-spinner"></i>
                    </div>
                  </ng-container>
                  <ng-template #showIcon>
                    <div class="button-icon">
                      <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                    </div>
                  </ng-template>
                  <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
                </div>
              
              </button>
              </ng-container>
            </ng-template>
        </app-toolbar>
    </div>
    <ng-content></ng-content>
  </div>
  <div class="blade-content">
    <div class="datex-form">
      <ng-container *ngIf="initialized && !$hasMissingRequiredInParams">
        <div [formGroup]="formGroup"
             class="formdata">
                <div data-cy="fieldset-id-newGroup1"
                     *ngIf="!fieldsets.newGroup1.hidden && !fieldsets.newGroup1.removed"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': fieldsets.newGroup1.collapsible }">
                    <div *ngIf="!fieldsets.newGroup1.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="fieldsets.newGroup1.toggle()">
                      <span class="fieldsetsTitle-text">
                      {{fieldsets.newGroup1.label}}
                      </span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="fieldsets.newGroup1.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !fieldsets.newGroup1.expanded, 'icon-ic_fluent_chevron_up_20_filled': fieldsets.newGroup1.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="fieldsets.newGroup1.expanded"
                         class="fieldsetsGroup">
                      <div data-cy="field-id-reasoncode" *ngIf="!fields.reasoncode.hidden && !fields.reasoncode.removed" 
                            class="field-container standard {{fields.reasoncode.invalid ? 'invalid' : ''}} {{fields.reasoncode.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.reasoncode.styles.style"
                            [ngClass]="fields.reasoncode.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.reasoncode.label + (fields.reasoncode.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.reasoncode.label}}<span *ngIf="fields.reasoncode.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <Invoices-reasoncodes_dd_single 
                            data-cy="selector"
                            [type]="fields.reasoncode.control.type"
                            formControlName="reasoncode"
                            (displayTextChange)="fields.reasoncode.control.displayText=$event"
                            [placeholder]="fields.reasoncode.control.placeholder"
                            [styles]="fields.reasoncode.control.styles"
                            [tooltip]="fields.reasoncode.control.tooltip"
                          [parentId]="$fields_reasoncode_selector_inParams_parentId"
                          [parentEntity]="$fields_reasoncode_selector_inParams_parentEntity"
                        >
                        </Invoices-reasoncodes_dd_single>
                        <ng-container *ngIf="fields.reasoncode.invalid">
                          <ng-container *ngFor="let error of fields.reasoncode.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>            </div>
        
                    <div class="fieldset-details" *ngIf="!fieldsets.newGroup1.expanded">
        
        
                    </div>
                  </div>
                </div>
                <div data-cy="fieldset-id-cancelOrder"
                     *ngIf="!fieldsets.cancelOrder.hidden && !fieldsets.cancelOrder.removed"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': fieldsets.cancelOrder.collapsible }">
                    <div *ngIf="!fieldsets.cancelOrder.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="fieldsets.cancelOrder.toggle()">
                      <span class="fieldsetsTitle-text">
                      {{fieldsets.cancelOrder.label}}
                      </span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="fieldsets.cancelOrder.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !fieldsets.cancelOrder.expanded, 'icon-ic_fluent_chevron_up_20_filled': fieldsets.cancelOrder.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="fieldsets.cancelOrder.expanded"
                         class="fieldsetsGroup">
                      <div data-cy="field-id-cancel_order" *ngIf="!fields.cancel_order.hidden && !fields.cancel_order.removed" 
                            class="field-container double {{fields.cancel_order.invalid ? 'invalid' : ''}} {{fields.cancel_order.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.cancel_order.styles.style"
                            [ngClass]="fields.cancel_order.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.cancel_order.label + (fields.cancel_order.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.cancel_order.label}}<span *ngIf="fields.cancel_order.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <mat-slide-toggle data-cy="slideToggle" formControlName="cancel_order"
                                      color="primary"
                                      class="datex-toggle"
                                      [ngStyle]="fields.cancel_order.control.styles.style"
                                      [ngClass]="fields.cancel_order.control.styles.classes"
                                      [matTooltip]="fields.cancel_order.control.tooltip"
                                      matTooltipClass="datex-control-tooltip">{{fields.cancel_order.control.label}}</mat-slide-toggle>
                        <ng-container *ngIf="fields.cancel_order.invalid">
                          <ng-container *ngFor="let error of fields.cancel_order.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-cancel_reason_code" *ngIf="!fields.cancel_reason_code.hidden && !fields.cancel_reason_code.removed" 
                            class="field-container standard {{fields.cancel_reason_code.invalid ? 'invalid' : ''}} {{fields.cancel_reason_code.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.cancel_reason_code.styles.style"
                            [ngClass]="fields.cancel_reason_code.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.cancel_reason_code.label + (fields.cancel_reason_code.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.cancel_reason_code.label}}<span *ngIf="fields.cancel_reason_code.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <Invoices-reasoncodes_dd_single 
                            data-cy="selector"
                            [type]="fields.cancel_reason_code.control.type"
                            formControlName="cancel_reason_code"
                            (displayTextChange)="fields.cancel_reason_code.control.displayText=$event"
                            [placeholder]="fields.cancel_reason_code.control.placeholder"
                            [styles]="fields.cancel_reason_code.control.styles"
                            [tooltip]="fields.cancel_reason_code.control.tooltip"
                          [parentId]="$fields_cancel_reason_code_selector_inParams_parentId"
                          [parentEntity]="$fields_cancel_reason_code_selector_inParams_parentEntity"
                        >
                        </Invoices-reasoncodes_dd_single>
                        <ng-container *ngIf="fields.cancel_reason_code.invalid">
                          <ng-container *ngFor="let error of fields.cancel_reason_code.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>            </div>
        
                    <div class="fieldset-details" *ngIf="!fieldsets.cancelOrder.expanded">
        
        
                    </div>
                  </div>
                </div>
              </div>
      </ng-container>

      <div *ngIf="$hasMissingRequiredInParams" class="missing-params">
        <h3>Please provide {{$missingRequiredInParams.toString()}}</h3>
      </div>
    </div>
  </div>
</div>